export const opcoesRescisao = {
  FLUXO_CAIXA: 'Fluxo de caixa não comporta o valor contratado',
  NAO_ATENDEU_EXPECTATIVA: 'Serviço não atende às expectativas',
  NAO_ACOMPANHOU_EVOLUCAO_MERCADO: 'Serviço não evoluiu conforme exigências do mercado',
  OPTOU_PELO_CONCORRENTE: 'Opção pelo serviço do concorrente',
  FALENCIA_FECHAMENTO: 'Falência / Fechamento da empresa',
  PRODUTO_OU_SERVICO_NAO_ATENDE: 'O produto é bom, mas o serviço não, e vice-versa',
  CRISE_FINANCEIRA: 'Crise financeira',
  OUTRO: 'Outro',
};
